/* RapidCare - product page: gallery thumbnails + variant selection.
   Add-to-cart, qty stepper, and accordions are handled globally
   (rc-global.js: data-rc-add / data-qty-step / data-accordion). */
(function () {
  'use strict';
  var root = document.querySelector('[data-rc-product]');
  if (!root) return;

  /* Gallery */
  var main = root.querySelector('[data-pdp-main]');
  root.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-pdp-thumb]');
    if (!thumb || !main) return;
    var full = thumb.getAttribute('data-full');
    var alt = thumb.getAttribute('data-alt') || '';
    if (full) main.innerHTML = '<img src="' + full + '" alt="' + alt.replace(/"/g, '&quot;') + '">';
    root.querySelectorAll('[data-pdp-thumb]').forEach(function (t) { t.classList.toggle('active', t === thumb); });
  });

  /* Variant selection */
  var select = root.querySelector('[data-variant-select]');
  if (select) {
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-variant-json]').textContent); } catch (e) {}
    var addBtn = root.querySelector('[data-rc-add]');
    var priceEl = root.querySelector('[data-pdp-price]');
    select.addEventListener('change', function () {
      var v = variants.filter(function (x) { return String(x.id) === select.value; })[0];
      if (!v) return;
      if (addBtn) {
        addBtn.setAttribute('data-variant-id', v.id);
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to Cart' : 'Sold Out';
      }
      if (priceEl && v.price_formatted) priceEl.textContent = v.price_formatted;
    });
  }
})();
